// src/components/GlobalModal.js
import React from 'react';
import ModalForms from './ModalForms';
import { useModalFeedback } from '../../context/ModalContext';

function GlobalModal() {
  const {
    showModal,
    message,
    showButtons,
    isDeleting,
    onConfirm,
    onCancel,
  } = useModalFeedback();

  if (!showModal) return null;

  return (
    <ModalForms
      message={message}
      onConfirm={onConfirm}
      onCancel={onCancel}
      isDeleting={isDeleting}
      showButtons={showButtons}
    />
  );
}

export default GlobalModal;
